import { render, staticRenderFns } from "./BuildingSiteSelector.vue?vue&type=template&id=81514f80&"
import script from "./BuildingSiteSelector.vue?vue&type=script&lang=js&"
export * from "./BuildingSiteSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports